import { FORMER_DOC_VERIFICATION_SUCCESS } from "../actions/types";

const initialState = {
  gemaltoLink:""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FORMER_DOC_VERIFICATION_SUCCESS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
